'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSharedHistoryContext = exports.SharedHistoryContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _LexicalHistoryPlugin = require("@lexical/react/LexicalHistoryPlugin");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { HistoryState } from '@lexical/react/LexicalHistoryPlugin'

// type ContextShape = {
// 	historyState?: HistoryState,
// };

const Context = /*#__PURE__*/(0, _react.createContext)({
  historyState: {
    current: null,
    redoStack: [],
    undoStack: []
  }
});
const SharedHistoryContext = _ref => {
  let {
    children
  } = _ref;
  const historyContext = (0, _react.useMemo)(() => ({
    historyState: (0, _LexicalHistoryPlugin.createEmptyHistoryState)()
  }), []);
  return /*#__PURE__*/_react.default.createElement(Context.Provider, {
    value: historyContext
  }, children);
};
exports.SharedHistoryContext = SharedHistoryContext;
const useSharedHistoryContext = () => (0, _react.useContext)(Context);
exports.useSharedHistoryContext = useSharedHistoryContext;
